module.exports = __webpack_public_path__ + "static/media/6.17.aaae8075.png";